import { useEffect, useState } from "react";
import { groupApi } from "../api/group.service";
import { GroupType } from "../types";

export const useGetAllGroups = (
  event_id: string,
  initialParams?: Record<string, any>
) => {
  const [params, setParams] = useState<Record<string, any>>(
    initialParams || {}
  );
  const [data, setData] = useState<GroupType[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<any>(null);

  const fetchData = async (
    event_id: string,
    fetchParams: Record<string, any>
  ) => {
    try {
      setLoading(true);

      const response: any = await groupApi.getAllGroups(event_id, fetchParams);

      setData(response?.data?.data?.groups ?? []);

      return true;
    } catch (err: any) {
      console.log("Get all groups failed:", err);

      setError(err.message || "Something wrong");

      return false;
    } finally {
      setLoading(false);
    }
  };

  return {
    data,
    fetchData,
    loading,
    error,
    params,
    setParams,
  };
};
